// Vuex
import consts from "@/consts.js";
import Request from './request';

async function fetch(data, noLoading) {
    return Request('get', "api/accounts", data, noLoading);
}

async function fetchAllNoPaging(data) {
    if (!data) data = {};
    // data.limit = consts.limitAll; //获取全部
    return Request('get', "api/accounts/", Object.assign({},data,{
        itemsPerPage: consts.limitAll,
        limit: consts.limitAll,
    }));
}

export default {
    fetch,
    fetchAllNoPaging,
};